import {CSSProperties, FC} from 'react'

import {theme} from '@/theme/theme'

// A gray shape used as a static loading placeholder. Animate the parent for a cohesive effect.
type SkeletonBlockProps = {
  width: string | number
  height: string | number
  borderRadius?: number | string
  flex?: CSSProperties['flex']
  color?: string
}

export const SkeletonBlock: FC<SkeletonBlockProps> = ({
  width,
  height,
  borderRadius = 4,
  flex,
  color = theme.palette.skeletonLoading.main,
}) => (
  <span
    style={{
      display: 'block',
      backgroundColor: color,
      width,
      height,
      borderRadius,
      flex,
    }}
  />
)
